import { render, staticRenderFns } from "./examRecords.vue?vue&type=template&id=68815256"
import script from "./examRecords.vue?vue&type=script&lang=js"
export * from "./examRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports